module.exports = __webpack_public_path__ + "static/img/logo.40d75ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/logos/logo.png
// module id = F2Cu
// module chunks = 1